import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'shopping_basket_checkout';
export const route = 'checkout/[shoppingId]/[onSuccessUrl]/[[...params]]';
export const ShoppingBasketCheckoutPage = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "shopping_basket_checkout" */
/* webpackPrefetch: true */
'../../components/CheckoutPage')));